module.exports = __webpack_public_path__ + "static/media/inventoryAptNotAvail.c807b872.svg";